<template>
  <div>
     <div v-for="(p,pix) in pict" :style="{'margin-top': '25px', 'padding-bottom': (50 + p.maxheight).toString() + 'px', position: 'relative'}" :key="pix.toString()">
        <span v-html="p.target"></span>
        <svg v-if="p.showfasit" :viewBox="'0 0 '+p.img.width+' '+p.img.height" :x="p.img.width + 30" y="0" :width="p.img.width" :height="p.img.height">
	   <image x="0" y="0" :width="p.img.width" :height="p.img.height" :href="urlonly(p.target)">
	   </image>
           <g v-for="(g,gix) in p.geom" :key="pix.toString()+'_s'+gix.toString()">
             <rect v-if="g.correct[0] == 'RECT'" :x="g.correct[1].split(',')[0]" :y="g.correct[1].split(',')[1]" :width="rwidth(g.correct)" :height="rheight(g.correct)" stroke-width="1" stroke="black" fill="none">
             </rect>
             <image :x="fasitxy(g)[0]" :y="fasitxy(g)[1]" :width="imgs[g.target].width" :height="imgs[g.target].height" :href="urlonly(g.target)">
	     </image>
           </g>
        </svg>

<VueDragResize v-for="(g,gix) in p.geom" :key="pix.toString()+'_'+gix.toString()" :ref="pix.toString()+'_'+gix.toString()" :isActive="true" :isDraggable="true" :isResizable="false" :parentLimitation="true" w="auto" h="auto" :parentH="p.img.height" :parentW="p.img.width" :x="g.xpos" :y="p.img.height + 25 + p.maxheight" v-on:dragstop="newcoord(pix.toString()+'_'+gix.toString())" v-html="g.target"></VueDragResize>
     </div>
     <input type="button" value="Sjekk svarene" v-on:click="sjekk" style="margin-top:30px" />
  </div>
</template>

<script>

   import ajaxmixin from './ajaxmixin.vue'
   import VueDragResize from 'vue-drag-resize'

   export default {

      name: 'dragdrop',
      
      mixins: [ajaxmixin],

      components: {
         VueDragResize,
      },

      props: {
        thisq: Object,
        tryonce: Boolean,
        record: Boolean,
        enbloc: Boolean,
        showscore: Boolean,
        token: String
      },

      data: function() {
        let pict = []
	let ch = this.thisq.choices
	let imgs = {}
	
	for (let c in ch) {
	   let alt = ch[c].alternatives[0]
	   let i = pict.findIndex(function(el) {return(el.target == ch[c].text)})
	   if (i == -1) {
	      let im = new Image();
	      im.src = ch[c].text.replace(/^<img\ src="/,'').replace(/".*$/,'')
	      let height = Number(ch[c].text.replace(/.*height="/,'').replace(/".*$/,''))
	      if (!isNaN(height)) {
	         im.height = height
	      }
	      let width = Number(ch[c].text.replace(/.*width="/,'').replace(/".*$/,''))
	      if (!isNaN(width)) {
	         im.width = width
	      }
	      pict.push({target: ch[c].text, geom: [], xpos: 20, img: im, maxheight: 0, showfasit: false})
	      i = pict.length - 1
	   }
	   if (!imgs.hasOwnProperty(alt.text)) {
	     let im = new Image();
	     im.src = alt.text.replace(/^<img\ src="/,'').replace(/".*$/,'')
	     imgs[alt.text] = im
	     pict[i].maxheight = Math.max((im.height == 0 ? 100 : im.height), pict[i].maxheight)
	   }
           pict[i].geom.push({correct: alt.correct.split(' '), xpos: pict[i].xpos, target: alt.text, drop: {top: 0, left: 0}, hit: null });
	   pict[i].xpos += (imgs[alt.text].width == 0 ? 100 : imgs[alt.text].width) + 20
	 
	}
	return ({
	   pict: pict,
	   ch: ch,
	   imgs: imgs
	})
      },

   
      methods: {
         fasitxy: function(geom) {
	    let center = []
	    let correct = geom.correct
	    switch(correct[0]) {
	       case 'RECT':
	          let ltop = correct[1].split(',')
	          let rbot = correct[2].split(',')
                  center = [ (Number(ltop[0]) + Number(rbot[0])) / 2, (Number(ltop[1]) + Number(rbot[1])) / 2 ]
		  break
	       case 'CIRCLE':
	          center = correct[1].split(',')
		  break;
	       case 'POLY':
		  break;
	    }
	    center[0] -= this.imgs[geom.target].width / 2
	    center[1] -= this.imgs[geom.target].height / 2
	    return(center)
	 },
	 
         urlonly: function(txt) {
	    return(txt.replace(/^<img\ src=\"/,'').replace(/\".*$/,''))
	 },
	 
         rwidth: function(g) {
            let l = g[1].split(',')
            let h = g[2].split(',')
            return(h[0]-l[0])
         },   

         rheight: function(g) {
            let l = g[1].split(',')
            let h = g[2].split(',')
            return(h[1]-l[1])
         },   

         newcoord: function(refcode) {
	    let pix = refcode.split('_')[0]
	    let gix = refcode.split('_')[1]
	    let el = this.pict[Number(pix)].geom[Number(gix)]
	    el.drop.top = this.$refs[refcode][0].top
	    el.drop.left = this.$refs[refcode][0].left
	 },

         inside: function(correct, pos) {
	    switch(correct[0]) {
	       case 'RECT':
	          let ltop = correct[1].split(',')
	          let rbot = correct[2].split(',')
		  return((((pos[0] <= rbot[0]) && (pos[0] >= ltop[0])) && ((pos[1] <= rbot[1]) && (pos[1] >= ltop[1]))));
		  break;
               case 'CIRCLE':
	          let c = correct[1].split(',')
		  let r = correct[2]
		  let rx = Math.sqrt(Math.pow(pos[0] - c[0], 2) + Math.pow(pos[1] - c[1], 2))
		  return(rx <= r);
		  break;
	       case 'POLY':
	          return(null);
		  break;
	    }
	 },
	 
	 sjekk: function() {
	    for (let p of this.pict) {
	      let pos = {}
	      for (let g of p.geom) {
	         if (!pos.hasOwnProperty(g.target)) {
		    pos[g.target] = []
		 }
		 pos[g.target].push([g.drop.left + this.imgs[g.target].width/2, g.drop.top + this.imgs[g.target].height/2])
	      }
	      for (let g of p.geom) {
	         let coord = pos[g.target]
		 for (let i in coord) {
		    if (this.inside(g.correct, coord[i])) {
		       delete coord[i]
		       g.hit = true
		       break
		    }
		 }
		 if (g.hit != true) {
		    g.hit = false
		 }

              }
              p.showfasit = true
	    }
	 }
      }
   }

</script>

